export default "__VITE_ASSET__K0d7Xv_kmrg9pjrMnixeoA__";